import React from 'react';
import { graphql, StaticQuery, navigate } from 'gatsby';
import styled from 'styled-components';
import './logo.css';

const SiteLogo = styled.img`
  max-height: 88px;
  width: 88px;
  // padding-top: 25px;
  display: inline-block;
  cursor: pointer;
  margin-left: 2px;
  @media (min-width: 500px) and (min-height: 500px) {
    // width: 100%;
    margin-left: inherit;
  }
`;

const LogoWrapper = styled.div`
    // width: 275px;
    margin-top: 8px;
    margin-bottom: 2px;

  // @media (min-width: 325px) and (min-height: 500px) {
  //    width: 300px;
  // }
`;

const redirectHome = () => {
  navigate('/home/');
};


const Logo = () => {
  const isBrowser = typeof window !== 'undefined';
  const pathname = isBrowser && window.location.pathname;
  const isHomepage = isBrowser && pathname.match('home') || pathname.length === 0;
  return (
    <StaticQuery
      query={graphql`
    {
        allWordpressWpLogo {
            edges {
            node {
                url {
                source_url
                }
            }
            }
        }
    }
    `}
      render={(props) => (
        <LogoWrapper onClick={redirectHome}>
          <SiteLogo src={props.allWordpressWpLogo.edges[0].node.url.source_url} />
          <span className="logo-text">
            <div className={`${!isBrowser || isHomepage ? 'logo-text-right' : ''}`}>
            Grimsby and
            </div>
            <div className={`${!isBrowser || isHomepage ? 'logo-text-left' : ''}`}>
            Cleethorpes
            </div>
            <div className={`${!isBrowser || isHomepage ? 'logo-text-right' : ''}`}>
            Museum
            </div>
          </span>
        </LogoWrapper>
      )}
    />
  );
};

export default Logo;
